import { FLAG_CREDIT_NOTE_REFUNDS } from 'config/env';
import { DetailsBooking } from 'types';

const getIsEligibleForCreditNoteRefund = (booking: DetailsBooking) => {
  if (!FLAG_CREDIT_NOTE_REFUNDS) {
    return false;
  }

  if (booking.reservation.cancellationPolicy?.activeCancellationWindow?.isNonRefundable ?? true) {
    return false;
  }

  if (booking.reservation.offer.type === 'classic') {
    return false;
  }

  return true;
};

export default getIsEligibleForCreditNoteRefund;
